export default {
    setSurveys(state, payload) {
        state.surveys = payload
    },
    setActiveSurveyID(state, payload) {
        state.activeSurveyID = payload
    },
    setActiveSurvey(state, payload) {
        state.activeSurvey = payload
    }
}